//Modules
import { useEffect, useState, Fragment } from 'react'

//Components
import Webdocs from '../../WebDocs/Webdocs'

function MaisInfoAcordItem({ item, index, articleColor, lang }) {
  const [randomID, setRandomId] = useState()
  const delimiterPattern = /\{\{(\d+)\}\}/g
  let foundPattern = []
  let match;

  useEffect(() => {
    setRandomId(Math.floor(Math.random() * 100000))
  } , [])

  while ((match = delimiterPattern.exec(item['content_'+lang])) !== null) {
    foundPattern.push(Number(match[1]));
  }
  delimiterPattern.lastIndex = 0;

  const parsedContent = item['content_'+lang].split(/\{\{\d+\}\}/g)

  return (
    <>
    {randomID &&
      <div className="card cardAccordion">
          <div className="card-header" style={articleColor} id={`heading_${index}_${item.id}_${randomID}`}>
              <button className="btn collapsed" type="button" data-toggle="collapse" data-target={`#collapse_${index}_${item.id}_${randomID}`} aria-expanded="false" aria-controls={`collapse_${index}_${item.id}_${randomID}`}>
                  <strong>{item['title_'+lang]}</strong>
                  <span></span>                                   
              </button>
          </div>

          <div id={`collapse_${index}_${item.id}_${randomID}`} className="collapse" aria-labelledby={`heading_${index}_${item.id}_${randomID}`} >
              <div className="card-body" style={articleColor}>                            
                <div>
                  {parsedContent.map((text, i) => (
                    <Fragment key={`${item.id}_${i}`}>
                      {text && <div dangerouslySetInnerHTML={{__html: text}} />}
                      {i < foundPattern.length && (
                        <Webdocs ramo={foundPattern[i]} showWebdocsTitle={item?.acf.hasOwnProperty('showWebdocsTitle') ? item?.acf.showWebdocsTitle : true} initial={true} articleColor={articleColor} />
                      )}
                    </Fragment>
                  ))}
                </div>
              
              </div>
          </div>
      </div>
    }
    </>
  )
}

export default MaisInfoAcordItem